'use strict';
import { cn_user_measure } from '../model/cn_user_measure';
import { cn_svg_map } from './cn_svg_map';
import { cn_edition_handler } from './cn_edition_handler';
import { cn_mouse_event } from './cn_mouse_event';
import { cn_edit_box } from './cn_edit_box';
import { cn_view_overlay } from './cn_view_overlay';
import { cn_dist } from '../utils/cn_utilities';
import { cn_overlay_camera } from './cn_overlay_camera';

const TOP_EDGE_POSITION = 7;
const RIGHT_EDGE_POSITION = 8;
const BOTTOM_EDGE_POSITION = 9;
const LEFT_EDGE_POSITION = 10;
const MOVE_HANDLE_POSITION = 3

export class cn_user_measure_handler extends cn_edition_handler {
    //***********************************************************************************
    /**
     * Constructor
     * @param {Array<cn_user_measure>} user_measures
     * @param {cn_svg_map | cn_view_overlay} map
     * @param {boolean} creation
     */
    constructor(user_measures, map, creation = false) {
        super(user_measures, map);

        this._map = map;
        this._view_overlay = (map.constructor == cn_view_overlay)?map:null;

        //*** marker
        this._user_measure = (user_measures.length == 1) ? user_measures[0] : null;
        this._user_measures = user_measures;

        //** mouse flags */
        this._mouseover_vertex = -1;
        this._selected_vertex = -1;

        //*** Edit box for mass selection */
        const edit_box = new cn_edit_box(this, user_measures, this._readOnly);
        this._handlers.push(edit_box);

        this._transaction_manager = map._building.transaction_manager;
        if (!this._readOnly) {
            edit_box.add_lock_pastille(this._transaction_manager);
        }
    }

    //***********************************************************************************
    //**** Draws
    //***********************************************************************************
    draw(camera) {
        let html = '';
        if (this._user_measure) {
            const is_3d = camera.is_3d();

            if (this._mouseover_vertex>=0)
                html += camera.draw_move_arrow(this._user_measure.positions[this._mouseover_vertex]);
        }

        //*** Draw handler */
        html += super.draw(camera);

        return html;
    }

    //***********************************************************************************
    //**** clear move effects
    //***********************************************************************************
    clear_move() {
        this._mouseover_vertex = -1;
        super.clear_move();
    }

    //***********************************************************************************
    //**** Mouse callbacks
    //***********************************************************************************

    /**
     * Grab event
     * @param {cn_mouse_event} mouse_event
     * @returns {boolean}
     */
    grab(mouse_event) {
        this.move(mouse_event)
        if (this._mouseover_vertex>=0) return true;
        return super.grab(mouse_event);
    }

    /**
     * Passive move event
     * @param {cn_mouse_event} mouse_event
     * @returns {boolean}
     */
    move(mouse_event) {
        if (this._user_measure && !this._user_measure.locked)
        {
            this._mouseover_vertex = this._user_measure.positions.findIndex(p => {
                let prj = mouse_event.camera.world_to_screen(p);
                if (!prj) return false;
                return cn_dist(prj,mouse_event.mouse_screen) < 20;
            });
            if (this._mouseover_vertex>=0) return true;
        }
        return super.move(mouse_event);
    }

    /**
     * Drag event
     * @param {cn_mouse_event} mouse_event
     * @returns {boolean}
     */
    drag(mouse_event) {
        if (this._mouseover_vertex < 0) return false;

        if (this._view_overlay)
        {
            let other_hook = {position:this._user_measure.positions[1-this._mouseover_vertex],normals:this._user_measure.normals[1-this._mouseover_vertex]};
            
            let hook = this._view_overlay._renderer.get_hook(mouse_event.mouse_screen[0], mouse_event.mouse_screen[1],10,other_hook);
            if (hook) {
                this._user_measure.positions[this._mouseover_vertex] = hook.position;
                this._user_measure.normals[this._mouseover_vertex] = hook.normals;
            }
        }
        return true;
    }
}

